import React from 'react';

const EditIcon = () => {
    return (
        <svg className="svg-inline" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.6569 5.83203H5.1569C4.71487 5.83203 4.29095 6.00763 3.97839 6.32019C3.66583 6.63275 3.49023 7.05667 3.49023 7.4987V14.9987C3.49023 15.4407 3.66583 15.8646 3.97839 16.1772C4.29095 16.4898 4.71487 16.6654 5.1569 16.6654H12.6569C13.0989 16.6654 13.5229 16.4898 13.8354 16.1772C14.148 15.8646 14.3236 15.4407 14.3236 14.9987V12.4987"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.65625 12.4995H10.1563L17.2396 5.4162C17.5711 5.08468 17.7574 4.63505 17.7574 4.1662C17.7574 3.69736 17.5711 3.24772 17.2396 2.9162C16.9081 2.58468 16.4584 2.39844 15.9896 2.39844C15.5207 2.39844 15.0711 2.58468 14.7396 2.9162L7.65625 9.99954V12.4995Z"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.4902 4.16602L15.9902 6.66602"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default EditIcon;
